module.exports = __webpack_public_path__ + "img/back_3.24b7dacd.png";